module.exports = __webpack_public_path__ + "static/media/dash.0f5d0cf5.svg";